const deviceSize = {
    mobile: 768,
    tablet: 1024,
};

export default deviceSize;
